import { ViewModelFactoryParams } from '../../../../utilsDeprecated/ControlledComponent/ControlledComponent.types';
import { CalendarStateDeprecated } from '../../controller';
import { CalendarContext } from '../../../../utilsDeprecated/context/contextFactory';
import { MemoizedViewModalFactory } from '../viewModel';
import { isSlotStartsOnDate } from '../../../../utilsDeprecated/slotAvailability/slotAvailability';
import {
  createWeekPickerViewModel,
  memoizedWeekPickerViewModel,
} from '../weekPickerViewModel/weekPickerViewModel';
import { WeeklyTimetableLayoutViewModel } from '../bodyViewModel/bodyViewModel.types';
import {
  getSlotsPerDaysInSelectedRange,
  SlotsFactory,
} from '../../../../utilsDeprecated/slotsPerDay/slotsPerDay';
import {
  AgendaSlotsViewModel,
  createAgendaSlotsViewModel,
  enrichSlotAvailability,
  memoizedAgendaSlotsViewModel,
} from '../agendaSlotsViewModel/agendaSlotsViewModel';

export const memoizedWeeklyTimetableLayoutViewModel: MemoizedViewModalFactory<WeeklyTimetableLayoutViewModel> =
  {
    dependencies: {
      state: ['slotsStatus', 'availableSlots', 'selectedRange'],
      settings: ['calendarLayout', 'noSessionsOffered'],
      subDependencies: [
        memoizedWeekPickerViewModel.dependencies,
        memoizedAgendaSlotsViewModel.dependencies,
      ],
    },
    createViewModel: createWeeklyTimetableLayoutViewModel,
  };

export function createWeeklyTimetableLayoutViewModel({
  state,
  context,
}: ViewModelFactoryParams<
  CalendarStateDeprecated,
  CalendarContext
>): WeeklyTimetableLayoutViewModel {
  const { slotsStatus, selectedRange } = state;

  let slotsPerDays;
  let weekPickerViewModel;
  if (selectedRange) {
    const slotsFactory = createAgendaSlotsFactory(state);
    slotsPerDays = getSlotsPerDaysInSelectedRange<AgendaSlotsViewModel>({
      slotsFactory,
      state,
      context,
    });
    weekPickerViewModel = createWeekPickerViewModel({ state, context });
  }

  return {
    slotsStatus,
    weekPickerViewModel,
    slotsPerDays,
  };
}

export const createAgendaSlotsFactory = (
  calendarState: CalendarStateDeprecated,
): SlotsFactory<AgendaSlotsViewModel> => {
  const { availableSlots } = calendarState;
  const enrichedSlotsAvailability = enrichSlotAvailability(
    availableSlots?.availabilityEntries,
  );

  return (
    dateAsLocalDate: string,
    state: CalendarStateDeprecated,
    context: CalendarContext,
  ) => {
    const enrichedSlotsAtSpecificDate =
      enrichedSlotsAvailability?.filter((slotAvailability) =>
        isSlotStartsOnDate({
          rfcStartTime: slotAvailability!.slot!.startDate!,
          dateAsLocalDate,
        }),
      ) || [];

    return createAgendaSlotsViewModel({
      state,
      context,
      slots: enrichedSlotsAtSpecificDate,
    });
  };
};
